export default __webpack_public_path__ + "static/media/Rectangle3.17453e24.svg";